import { CurateResource } from "../Types/Curate/CurateResource";

/** Shape the server's access-checked "resources" stream event into tiles the UI can render. */
export const normalizeCurateResources = (raw: unknown): CurateResource[] => {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      const r = item as Record<string, unknown>;
      const id = String(r.id ?? "");
      if (!id) return null;
      return {
        id,
        Title: String(r.Title ?? r.title ?? ""),
        Description: String(r.Description ?? r.description ?? ""),
        providerId: r.providerId ? String(r.providerId) : undefined,
        kind: r.kind ? String(r.kind) : undefined,
        extension: r.extension ? String(r.extension) : undefined,
        url: r.url ? String(r.url) : undefined,
        page: typeof r.page === "number" && r.page >= 1 ? r.page : undefined,
        pageCount: typeof r.pageCount === "number" && r.pageCount >= 1 ? r.pageCount : undefined,
      } as CurateResource;
    })
    .filter((r): r is CurateResource => !!r);
};
